import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { AccountFirmwareUpdateInfo } from '../models/firmware-update/account-firmware-update-info.model';
import { ConnectedDeviceWithFirmwareInfo } from '../models/user-registration/connected-device-with-firmware-info.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class FirmwareApiService extends ApiService
{

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService,
                protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    getAccountFirmwareWithInfo(accountId: number): Observable<ConnectedDeviceWithFirmwareInfo[]>
    {
        return this.apiRequest(this.apiUrlService.getFirmwareInfoUrl(accountId), this.HttpMethod.Get)
            .pipe(
                map((response: ConnectedDeviceWithFirmwareInfo[]) =>
                {
                    const connectedDevicesWithFirmwareInfo = [];
                    response.forEach(deviceWithFirmwareInfo =>
                    {
                        connectedDevicesWithFirmwareInfo.push(new ConnectedDeviceWithFirmwareInfo(deviceWithFirmwareInfo));
                    });
                    return connectedDevicesWithFirmwareInfo;
                })
            );
    }

    getAccountFirmwareUpdateInfo(accountId: number): Observable<AccountFirmwareUpdateInfo>
    {
        return this.apiRequest(this.apiUrlService.getFirmwareUpdateInfoUrl(accountId), this.HttpMethod.Get)
            .pipe(map(response => new AccountFirmwareUpdateInfo(response)));
    }

    upgradeFirmware(accountId: number, deviceIds: number[]): Observable<any>
    {
        const queryString = this.createQueryStringForUpgradeFirmwareUrl(deviceIds);
        return this.apiRequest(this.apiUrlService.getUpgradeFirmwareUrl(accountId, queryString), this.HttpMethod.Post);
    }

    upgradeDevicesFirmware(accountId: number, deviceIds: number[]): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.getUpgradeDevicesFirmwareUrl(accountId), this.HttpMethod.Post, deviceIds);
    }


    cancelFirmwareUpgrade(deviceId: number, deviceTypeId: number): Observable<any>
    {
        return this.apiRequest(this.apiUrlService.getCancelFirmwareUpgradeUrl(deviceId, deviceTypeId), this.HttpMethod.Post);
    }

    // Helper Methods
    private createQueryStringForUpgradeFirmwareUrl(deviceIds: number[]): string
    {
        let queryString = '';
        for (let i = 0; i < deviceIds.length; i++)
        {
            queryString += `${i === 0 ? '?' : '&'}deviceIds=` + deviceIds[i].toString();
        }
        return queryString;
    }
}
